import React, { useEffect, useState } from "react";
import axios from 'axios';
import { IonPage, IonContent, useIonAlert } from '@ionic/react';
import HeaderSos3 from "../components/HeaderSos3";
import './ButtonSos3.css';
import Footer from "../components/Footer";
import WA from '../asset/img/wa.png';
import env from '../env.json'

// const PHP_PROXY_URL_HOME_SECTIONS = 'https://portal.mastinseguridad.com/apisapp/ga_proxy.php';

// const getOrCreateGaClientIdForHome = (): string => {
//   let clientId = localStorage.getItem('ga_client_id');
//   if (!clientId) {
//     clientId = typeof self !== 'undefined' && self.crypto?.randomUUID ? 
//                self.crypto.randomUUID() : 
//                `uuid-${Date.now()}-${Math.random().toString(36).substring(2)}`;
//     localStorage.setItem('ga_client_id', clientId);
//   }
//   return clientId;
// };

// const user = localStorage.getItem('profile') as string;
// const profile = user ? JSON.parse(user) : null;
// const userIdForGa = profile?.id?.toString() ?? undefined; 

// const clientIdForGa = getOrCreateGaClientIdForHome();

// const payloadToProxyHome = {
//   client_id: clientIdForGa,
//   user_id: userIdForGa, 
//   event_name: 'page_view', 
//   event_params: {         
//     page_location: '/pages/SOS',
//     page_title: 'SOS'
//   }
// };

// console.log('SOS Enviando page_view inicial a proxy GA:', payloadToProxyHome);
// fetch(PHP_PROXY_URL_HOME_SECTIONS, {
//   method: 'POST',
//   headers: { 'Content-Type': 'application/json' },
//   body: JSON.stringify(payloadToProxyHome)
// })
// .then(response => {
//   if (!response.ok) {
//     response.json().then(err => console.error('Error desde proxy GA (SOS page_view):', err)).catch(() => console.error('Error desde proxy GA (Home page_view), respuesta no JSON'));
//   } else {
//     response.json().then(data => console.log('Éxito vía proxy GA (SOS page_view):', data)).catch(() => console.log('Éxito vía proxy GA (Home page_view), respuesta no JSON'));
//   }
// })
// .catch(error => {
//   console.error('Error de red contactando proxy GA (SOS page_view):', error);
// });


const ButtonSos3: React.FC = () => {


    const token = localStorage.getItem('token');
    const url = env.REACT_APP_URL;

    const [present] = useIonAlert();
    const [lat, setLat] = useState(0);
    const [lng, setLng] = useState(0);
    const [id, setId] = useState(0);
    const [key, setKey] = useState(0);

    const getSosId = async () => {
        const token = localStorage.getItem('token');
        const header = {
            'Authorization': 'Bearer ' + token
        }

        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/sos/0')
            .then(res => {
                console.log(res.data.id)
                //key = res.data.key;
                setId(res.data.id);
            })
    }

    async function getKey() {
        const token = localStorage.getItem('token');
        const header = {
            'Authorization': 'Bearer ' + token
        }

        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        await instance.get('/api/getkey/maps')
            .then(res => {
                console.log(res.data)
                setKey(res.data);
            })
    }

    async function geoFindMe() {
        function success(position: any) {
            const latitude = position.coords.latitude;
            const longitude = position.coords.longitude;
            setLat(latitude);
            setLng(longitude);
        }

        function error() {
            console.log('No se encontró la direccion');
        }

        navigator.geolocation.getCurrentPosition(success, error);
    }


    // BOTON WHATSAPP
    const sendWA = () => {

        let text = "Tengo una emergencia";

        const data = localStorage.getItem('profile') as string;
        const profile = JSON.parse(data);

        let phoneCall = profile.contact_phone_help;

        window.open("https://api.whatsapp.com/send/?phone=57" + phoneCall + "&message=" + text, '_system');
    }

    const updateState = async (code: any, button: String) => {
        const header = {
            'Authorization': 'Bearer ' + token
        }
        const instance = axios.create({
            baseURL: url,
            headers: header
        })

        console.log('/api/sos/' + id)
        await instance.put('/api/sos/' + id, {
            "number": id,
            "password": code['PIN'],
            "button": button
        })
            .then(res => {
                if (res.data === "") {
                    console.log(res.data, res);
                    alert('Contraseña incorrecta! verifica');
                }

                else {
                    localStorage.removeItem('status');
                    window.location.href = '/';
                    console.log('Cerrando caso...')
                }

            })
            .catch(e => alert('Algo salió mal :c'))
    }

    useEffect(() => { geoFindMe() }, [])
    useEffect(() => { getSosId() }, [])
    useEffect(() => { getKey() }, [])

    return (
        <IonPage>
            <HeaderSos3 pageName="Botón SOS" />
            <IonContent className='sos-3'>

                <div className="map-container">
                    <div >
                        <iframe
                            title="find-me-title"
                            id="find-me"
                            className="map"
                            width="450"
                            height="250"
                            frameBorder="0"
                            referrerPolicy="no-referrer-when-downgrade"
                            src={`https://www.google.com/maps/embed/v1/place?key=${key}&center=${lat},${lng}&q=${lat},${lng}`}
                            allowFullScreen
                        >
                        </iframe>
                    </div>
                </div>
                <div className="btns-sos">
                    <button
                        className="btn-error"
                        onClick={() =>
                            present({
                                cssClass: 'my-css',
                                header: '',
                                message: 'Escriba su contraseña para aprobar el cierre del caso:\n',
                                inputs: [
                                    {
                                        name: 'PIN',
                                        placeholder: 'Contraseña',
                                        type: "password"
                                    }
                                ],
                                buttons: [
                                    {
                                        text: 'Aceptar',
                                        handler: (d) => {
                                            updateState(d, 'Fue un error');
                                        }
                                    },
                                ]
                            })}
                    >Fue un error</button>
                    <button
                        className="btn-allright"
                        type="submit"
                        onClick={() =>
                            present({
                                cssClass: 'my-css',
                                header: '',
                                message: 'Escriba su contraseña para aprobar el cierre del caso:\n',
                                inputs: [
                                    {
                                        name: 'PIN',
                                        placeholder: 'Contraseña',
                                        type: "password"
                                    }
                                ],
                                buttons: [
                                    {
                                        text: 'Aceptar', handler: (d) => {
                                            updateState(d, 'Ya estoy bien');
                                        }
                                    },
                                ]
                            })}
                    >
                        Ya estoy bien
                    </button>
                </div>
                <div className="wa">
                    <img src={WA} onClick={sendWA} alt="wa" />
                </div>
            </IonContent>
            <Footer />
        </IonPage>
    );
}

export default ButtonSos3;